// Real platform config below. Fake demo sellers/products/reviews/purchases/wallet
// transactions/notifications that used to live in this file were unused by the app
// (products, sellers, etc. are fetched live from Supabase — see src/lib/queries.ts)
// and have been removed since nothing is listed on the marketplace yet except Hostevr.

export const SUBSCRIPTION_PLANS = [
  {
    id: 'plan-free',
    name: 'Free',
    tier: 0,
    price_monthly: 0,
    platform_fee_pct: 7,     /* no commitment — ~10% all-in, on par with Gumroad/Etsy */
    buyer_discount_pct: 0,   /* discount always funded by the seller's cut, never Aiphra's fee */
    max_products: 3,
    payout_speed_days: 7,
    search_boost: 0,
    homepage_featured: false,
  },
  {
    id: 'plan-starter',
    name: 'Starter',
    tier: 1,
    price_monthly: 8,        /* low entry price point */
    platform_fee_pct: 6,     /* fee savings alone pay for itself above ~$800/mo revenue */
    buyer_discount_pct: 3,
    max_products: 5,
    payout_speed_days: 5,
    search_boost: 0,
    homepage_featured: false,
  },
  {
    id: 'plan-pro',
    name: 'Pro',
    tier: 2,
    price_monthly: 24.99,
    platform_fee_pct: 5,     /* fee savings alone pay for itself above ~$1,700/mo revenue */
    buyer_discount_pct: 6,
    max_products: 20,
    payout_speed_days: 3,
    search_boost: 1,
    homepage_featured: false,
  },
  {
    id: 'plan-elite',
    name: 'Elite',
    tier: 3,
    price_monthly: 79.99,
    platform_fee_pct: 4,     /* fee savings alone pay for itself above ~$5,500/mo revenue — ~7% all-in */
    buyer_discount_pct: 10,
    max_products: null,
    payout_speed_days: 1,
    search_boost: 2,
    homepage_featured: true,
  },
];

export const CATEGORY_META: Record<string, { label: string; color: string; icon: string }> = {
  ai_agents: { label: 'AI Agents', color: 'var(--accent-primary)', icon: 'bot' },
};

/** Use-case categories for browsing within the AI Agents category. Matched against product tags. */
export const AI_AGENT_USE_CASES: { label: string; tag: string }[] = [
  { label: 'Productivity',          tag: 'Productivity' },
  { label: 'Customer Support',      tag: 'Customer Support' },
  { label: 'Sales & Marketing',     tag: 'Sales & Marketing' },
  { label: 'Content & Writing',     tag: 'Content & Writing' },
  { label: 'Coding & Development',  tag: 'Coding & Development' },
  { label: 'Data & Analytics',      tag: 'Data & Analytics' },
  { label: 'Research & Knowledge',  tag: 'Research & Knowledge' },
  { label: 'Personal Assistant',    tag: 'Personal Assistant' },
  { label: 'Finance & Accounting',  tag: 'Finance & Accounting' },
  { label: 'HR & Recruiting',       tag: 'HR & Recruiting' },
  { label: 'Design & Creative',     tag: 'Design & Creative' },
  { label: 'DevOps & Automation',   tag: 'DevOps & Automation' },
  { label: 'Healthcare',            tag: 'Healthcare' },
  { label: 'Legal',                 tag: 'Legal' },
  { label: 'Education',             tag: 'Education' },
  { label: 'Other',                 tag: 'Other' },
];
